'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */

var SexualContent = function (_BcReactComponent) {
  _inherits(SexualContent, _BcReactComponent);

  function SexualContent() {
    _classCallCheck(this, SexualContent);

    return _possibleConstructorReturn(this, (SexualContent.__proto__ || Object.getPrototypeOf(SexualContent)).apply(this, arguments));
  }

  _createClass(SexualContent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-sexual-content', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { className: 'path1', d: 'M16 6.877l-0.157-0.005c-1.935-0.112-3.646-2.091-5.593-2.091-2 0-2.25 0.75-2.25 0.75s-0.25-0.75-2.25-0.75c-1.948 0-3.658 1.979-5.593 2.091l-0.157 0.005c0 0 5 0.904 8 0.904s8-0.904 8-0.904zM8 9.219c-2.637 0-7-1.531-7.793-2.138 2.25 1.722 3.894 4.794 7.793 4.794s5.543-3.073 7.793-4.794c-0.793 0.607-5.156 2.138-7.793 2.138z' })
      );
    }
  }]);

  return SexualContent;
}(_baseBcReactComponent2.default);

exports.default = SexualContent;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/SexualContent/SexualContent.js
// module id = 1283
// module chunks = 1